import Vue from 'vue'
import baseLayout from '@/components/BaseLayout'
import svgIcon from '@/components/SvgIcon'
import snackbar from '@/components/Snackbar'

Vue.component('base-layout', baseLayout)
Vue.component('svg-icon', svgIcon)
Vue.component('snackbar', snackbar)
